

















import Vue from 'vue';
import { mapState } from 'vuex';
import { PaymentSystem } from '../../../constants/paymentSystem';
import { HotelInterface } from '../../../types/hotelInterface';
import TheLangSwitcher from '@/components/common/TheLangSwitcher.vue';

export default Vue.extend({
  name: 'ThePageMenu',
  components: {
    TheLangSwitcher,
  },
  props: {
    isDashboard: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      hotel(state: any): HotelInterface {
        return this.isDashboard ? state.dashboard.hotel : state.landing.hotel.item;
      },
    }),
    isPaymentSystemActivated(): boolean {
      if (window.location.href.includes('demo-landing') || this.isDashboard) {
        return true;
      }
      return this.$store.state.landing.settings.payment_system_activated;
    },
    isGMO(): boolean {
      const paymentSystem = this.isDashboard
        ? this.$store.state.dashboard.settings.payment_system
        : this.$store.state.landing.settings.payment_system;
      return paymentSystem === PaymentSystem.GMO;
    },
    links(): Array<any> {
      const list = [
        {
          isLink: true,
          key: 'legal-info.name',
          url: '/legal-info',
          isAvailable: this.isGMO && this.isPaymentSystemActivated,
        },
        {
          isLink: true,
          key: 'privacy-policy.title',
          url: '/privacy-policy',
          isAvailable: true,
        },
      ];
      return list.filter(item => item.isAvailable);
    },
  },
});
